import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/pyramidbet/images/racing/mysteryBetLogo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 1,
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'odds', h: '38px', borderRadius: 'base' },
  imageLogo: {
    w: '250px',
    src: mysteryLogo,
    mt: '2',
  },
  iconMystery: {
    mb: '1',
  },
  textSlash: {
    color: 'whiteAlpha.400',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  flexWrapperMysteryLabelView: {
    color: 'white',
    fontFamily: 'body',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'bold',
    gap: 1,
    lineHeight: 'normal',
    alignItems: 'center',
    sx: {
      '&&': {
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  buttonAddToBetslip: {
    variant: 'solid',
    sx: {
      '&&': {
        borderLeftRadius: 'none',
        borderRightRadius: 'base',
        textTransform: 'uppercase',
        fontWeight: 'black',
        ms: '0',
        fontSize: '11px',
      },
      _disabled: {
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
        color: 'alpha.300',
        textShadow: 'none',
        pointerEvents: 'none',
        _before: {
          display: 'none',
        },
      },
    },
  },
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    borderRightRadius: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: ['2xs', null, 'xs'],
    fontFamily: 'body',
    fontWeight: 'bold',
    sx: {
      '&&': {
        px: [2, 3],
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    px: '3',
    color: 'gamma.200',
    overflow: 'hidden',
    mx: 'auto',
  },
  flexWrapperMysteryPlacedBetView: {
    fontFamily: 'ProximaNova',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    p: '2',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
    mx: ['0', null, '2'],
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bgGradient: 'linear(to-b, beta.700, beta.900)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: 'lg',
    boxSize: '10',
    p: '0',
    w: '40px',
    h: '40px',
    color: 'blackAlpha.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    cursor: 'pointer',
  },
  flexWrapperWithTooltip: {
    gap: 1,
  },
  imageMysteryBet: {
    w: '5',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    fontSize: ['2xs', null, 'xs'],
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'bold',
    textShadow: 'none',
    fontStyle: 'normal',
    textTransform: 'uppercase',
  },
  textPriceInfo: {
    fontSize: ['2xs', null, 'xs'],
    color: 'beta.100',
    fontFamily: 'accent',
    fontWeight: 'bold',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  textRollover: {
    fontSize: ['2xs', null, 'xs'],
    color: 'beta.100',
    fontFamily: 'accent',
    fontWeight: 'bold',
    textShadow: 'none',
    fontStyle: 'normal',
    textTransform: 'uppercase',
  },
  textError: {
    color: 'white',
    fontFamily: 'body',
    fontWeight: 'normal',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontStyle: 'normal',
    fontSize: ['2xs', null, 'xs'],
  },
  iconBack: {
    boxSize: '7',
    color: 'white',
  },
  iconRace: { color: 'alpha.300', mb: '2' },
  textSpanWhite: {
    color: 'white',
    textTransform: 'capitalize',
    fontFamily: 'body',
    fontWeight: 'bold',
  },
  buttonRollOver: {
    variant: 'secondary',
    borderRadius: 'base',
    h: '7',
    _disabled: {
      bg: 'blackAlpha.500',
      boxShadow:
        '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
      color: 'beta.100',
      textShadow: 'none',
      _before: {
        display: 'none',
      },
    },
  },
  spanSelectionText: {
    color: 'alpha.100',
    textTransform: 'uppercase',
    fontFamily: 'body',
    fontWeight: 'bold',
  },
  spanPositionType: {
    color: 'beta.300',
    textTransform: 'capitalize',
    fontFamily: 'body',
    fontWeight: 'bold',
  },
  tooltipIcon: {
    color: 'alpha.300',
    fill: 'alpha.300',
  },
  buttonGroupAddToBetslip: {
    mr: '1',
    alignItems: 'center',
    maxW: ['250px', null, 'unset'],
  },
};
